<template>
  <s-modal
    v-model:open="open"
    :title="t('title')"
    :tagline="t('tagline')"
    :confirm="{
      label: t('actions.applyAll'),
      icon: 'check',
    }"
    confirmable
    cancellable
    @confirm="apply"
    width="md"
  >
    <template #content>
      <p class="mb-2">
        {{ t('description') }}
      </p>
      <s-checkbox id="reviewRequired" :label="t('labels.reviewRequired')" v-model="form.review" />

      <p v-if="mixed" class="text-sm text-gray-500 mt-2">
        {{ t('warning.mixed') }}
      </p>
    </template>
  </s-modal>
</template>
<script setup lang="ts">
import SModal from '../../../design-system/SModal.vue';
import {reactive, ref, watch} from 'vue';
import SInputField from '../../../design-system/SInputField.vue';
import {CreateTaskAssignmentDto} from '../task-assignment-factory';
import {useI18n} from 'vue-i18n';
import SCheckbox from '../../../design-system/SCheckbox.vue';

const open = defineModel('open', {default: false});
const taskAssignments = defineModel('taskAssignments', {default: [] as CreateTaskAssignmentDto[]});

const form = reactive({
  review: null as boolean | null,
});

const mixed = ref(false);

watch(open, (isOpen) => {
  if (isOpen) {
    const review = taskAssignments.value[0]?.reviewRequired || null;

    mixed.value = !taskAssignments.value.every(({reviewRequired}) => reviewRequired === review);

    form.review = mixed.value ? null : review;
  }
});

const apply = () => {
  taskAssignments.value.forEach((ta) => {
    ta.reviewRequired = form.review;
  });
};

const {t} = useI18n({
  useScope: 'local',
  inheritLocale: true,
});
</script>
<i18n>
{
  "en": {
    "title": "Manual Review",
    "tagline": "Editing all tasks",
    "actions.applyAll": "Apply to all Tasks",
    "description": "Toggle whether or not grades and feedback need to be reviewed for all tasks.",
    "warning.mixed": "Note: Some tasks have different review settings.",
    "labels.reviewRequired": "Require Review"
  },
  "fr": {
    "title": "Révision manuelle",
    "tagline": "Édition de toutes les tâches",
    "actions.applyAll": "Appliquer à toutes les tâches",
    "description": "Basculer si les notes et les commentaires doivent être examinés pour toutes les tâches.",
    "warning.mixed": "Remarque : certaines tâches ont des paramètres de révision différents.",
    "labels.reviewRequired": "Exiger la révision"
  }
}
</i18n>
